import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { FlexContainerText } from "@/modules/flex-container";

const RecommendedBy = ({ recommendedBy, loading }) => {
  const { t } = useTranslation();

  if (!recommendedBy || loading) return null;

  const firstObservation = recommendedBy.observations?.[0];

  return (
    <FlexContainerText
      value={recommendedBy.name}
      link={`/interventions/${recommendedBy.id}?observation_id=${firstObservation}`}
      label={t("recommendation:recommendedBy.label")}
      direction="row"
    />
  );
};

RecommendedBy.propTypes = {
  recommendedBy: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    state: PropTypes.string,
    observations: PropTypes.arrayOf(PropTypes.number),
  }),
  loading: PropTypes.bool,
};

export default RecommendedBy;
